import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { AWARD_QUERY } from '../graphql/queries'
import { FETCH_AWARD } from '../redux/action-types'
import { cleanupFetchAward } from '../redux/actions'

const useAwardQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchAward)

  const { isLoading, error, data } = useSelector(store => store.awards.award)

  const refetch = useCallback(
    id => apolloService.query(AWARD_QUERY, { id }, dispatch, FETCH_AWARD),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading, error, data }
}

export default useAwardQuery
